import React from 'react';
import { useTranslation } from 'react-i18next';
import config from 'react-global-configuration';

import Dossier from '../../../components/Molecules/Dossier';

import './style.scss';

const WorkfieldsTheme = ({ title, entities }) => {
  const { t } = useTranslation();
  const language = config.get('DEFAULT_LANGUAGE');
  return entities && entities.size > 0 && (
    <>
      <h4>{title}</h4>
      <div className="WorkfieldsThemeContent">
        <div className="WorkfieldsThemeContent__Items">
          {entities.map((entity) => {
            const url = entity.getIn(['paths', language]);
            const itemTitle = entity.getIn(['name', 0, 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const image = entity.getIn(['field_media_image', 0, 'styles', '1_1'], null);
            const imageAlt = entity.getIn(['field_media_image', 0, 'alt'], '');

            return (
              <Dossier
                key={uuid}
                image={image}
                imageAlt={imageAlt}
                type={t('tags.workfield')}
                link={url}
                body={itemTitle}
                small
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default WorkfieldsTheme;
